module.exports = __webpack_public_path__ + "static/media/plane.92e1d1ab.svg";